var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "hourglass_svg__a",
    width: 8,
    height: 12,
    x: 1,
    y: 0,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 0h8v12H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 4.599A3 3 0 0 0 8 2V1H2v1c0 1.11.603 2.08 1.5 2.599v.013a1.5 1.5 0 0 1 0 2.776V7.4A3 3 0 0 0 2 10v1h6v-1c0-1.11-.603-2.08-1.5-2.599v-.013a1.5 1.5 0 0 1 0-2.776z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF50",
    fillRule: "evenodd",
    d: "M6.5 4.599A3 3 0 0 0 8 2V1H2v1c0 1.11.603 2.08 1.5 2.599v.013a1.5 1.5 0 0 1 0 2.776V7.4A3 3 0 0 0 2 10v1h6v-1c0-1.11-.603-2.08-1.5-2.599v-.013a1.5 1.5 0 0 1 0-2.776z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262929",
    d: "M6.5 4.599 6 3.733a1 1 0 0 0-.5.866zM8 1h1a1 1 0 0 0-1-1zM2 1V0a1 1 0 0 0-1 1zm1.5 3.599h1a1 1 0 0 0-.5-.866zm0 .013h-1a1 1 0 0 0 .62.925zm0 2.776-.38-.925a1 1 0 0 0-.62.925zm0 .013.5.866a1 1 0 0 0 .5-.866zM2 11H1a1 1 0 0 0 1 1zm6 0v1a1 1 0 0 0 1-1zM6.5 7.401h-1a1 1 0 0 0 .5.866zm0-.013h1a1 1 0 0 0-.62-.925zm0-2.776.38.925a1 1 0 0 0 .62-.925zM7 2c0 .739-.4 1.386-1 1.733l1 1.731C8.195 4.774 9 3.482 9 2zm0-1v1h2V1zM2 2h6V0H2zm1 0V1H1v1zm1 1.733C3.4 3.386 3 2.739 3 2H1c0 1.482.806 2.774 2 3.464zm.5.88v-.014h-2v.013zM5.43 6a2.5 2.5 0 0 0-1.55-2.313l-.76 1.85A.5.5 0 0 1 3.43 6zM3.88 8.313A2.5 2.5 0 0 0 5.43 6h-2a.5.5 0 0 1-.31.463zM4.5 7.4v-.013h-2V7.4zM3 10c0-.739.4-1.386 1-1.733L3 6.536C1.805 7.226 1 8.518 1 10zm0 1v-1H1v1zm5-1H2v2h6zm-1 0v1h2v-1zM6 8.267c.6.347 1 .994 1 1.733h2a4 4 0 0 0-2-3.464zm-.5-.88v.014h2v-.013zM4.57 6a2.5 2.5 0 0 0 1.55 2.313l.76-1.85A.5.5 0 0 1 6.57 6zm1.55-2.313A2.5 2.5 0 0 0 4.57 6h2a.5.5 0 0 1 .31-.463zM5.5 4.6v.013h2V4.6z",
    mask: "url(#hourglass_svg__a)"
  })));
};
export default SvgHourglass;